interface MapProps {
  address?: string;
  latitude?: string;
  longitude?: string;
  zoom?: number;
  height?: 'sm' | 'md' | 'lg';
}

const HEIGHT_MAP: Record<string, string> = { sm: '250px', md: '400px', lg: '550px' };

export function MapBlock({ props }: { props: MapProps }) {
  const lat = props.latitude ?? '41.9028';
  const lng = props.longitude ?? '12.4964';
  const zoom = props.zoom ?? 14;
  const h = HEIGHT_MAP[props.height ?? 'md'] ?? '400px';

  // Use OpenStreetMap embed (free, no API key)
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${Number(lng) - 0.01},${Number(lat) - 0.01},${Number(lng) + 0.01},${Number(lat) + 0.01}&layer=mapnik&marker=${lat},${lng}`;

  return (
    <div className="w-full overflow-hidden rounded-lg" style={{ height: h }}>
      <iframe
        src={src}
        className="w-full h-full border-0"
        title={props.address ?? 'Map'}
        loading="lazy"
      />
      {props.address && (
        <div className="bg-zinc-50 px-4 py-2 text-sm text-zinc-600">{props.address}</div>
      )}
    </div>
  );
}
